// Vue
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Components
import { Observer } from "mobx-vue";
import { Abhbox } from "./abhbox/Abhbox";
import { Searchbox } from "./searchbox/Searchbox";
import { Map } from "./map/Map";

/* import "@mgs/ci2019-common/src/components/shared/map/heremaps/js/mapsjs-core.js";
import "@mgs/ci2019-common/src/components/shared/map/heremaps/js/mapsjs-service.js";
import "@mgs/ci2019-common/src/components/shared/map/heremaps/js/mapsjs-ui.js";
import "@mgs/ci2019-common/src/components/shared/map/heremaps/js/mapsjs-mapevents.js";
import "./heremaps/js/mapjs-clustering.js"; */
import { AbhHandlersuche } from "../../common/interfaces/unimog/AbhHandlersuche";

@Observer
@Component({
  mixins: [template],
  components: {
    Abhbox,
    HaendlersucheMap: Map,
    Searchbox,
  },
})
export class Haendlersuche extends Vue {
  @Prop({ default: null })
  private abhData!: AbhHandlersuche | null;

  @Prop({ default: [] })
  public points!: H.geo.IPoint[];

  @Prop()
  public translation!: object;

  @Prop({ default: true })
  public showBackLink!: boolean;

  private selectedPoints: H.geo.IPoint[] = [];

  private myLocation: H.geo.IPoint | null = null;

  private currentLocation: H.geo.IPoint | null = null;

  private selectedHaendler: object | null = null;

  public onUpdatedSelectedPoints(points) {
    this.selectedPoints = points;
  }

  public onChangeMyLocation(point) {
    this.myLocation = point;
  }

  public onChangeCurrentLocation(location) {
    this.currentLocation = location;
  }

  public onSelectHaendler(handler) {
    this.selectedHaendler = handler;
  }
}
